import { ReasonOption } from "../../../src/models/schedule-change-model";
import { VesselCLFPopup } from "./vessel-clf-popup";
import './vessel-clf-popup';

interface CreateClfOptions
{
    headerText: string;
    bodyText: string;
    reasonOptions: Record<string, ReasonOption>;
    hasDateInput?: boolean;
    etaBerth?: string;
    etaPilot?: string;
}

type ClfResponse =
    | { status: "submit"; reason: string; reasonCode: string; comment: string; date?: string }
    | { status: "cancel" };

export const VesselCLFPopupManager = new class {
    private clfElement: VesselCLFPopup | null = null;
    private response: Promise<ClfResponse> | null = null;
    
    createClf(options: CreateClfOptions){
        if (this.clfElement && this.response) {
            const response = this.response;
            return {
                getResponse: () => response,
            };
        }

        this.clfElement = document.createElement('vessel-clf-popup') as VesselCLFPopup;
        const clfElement = this.clfElement;
        this.clfElement.shown = true;
        this.clfElement.headerText = options.headerText;
        this.clfElement.bodyText = options.bodyText;
        this.clfElement.reasonOptions = options.reasonOptions;
        if(options.hasDateInput)
            this.clfElement.hasDateInput = options.hasDateInput;

        if(options.etaBerth)
            this.clfElement.etaBerth = options.etaBerth;

        if(options.etaPilot)
            this.clfElement.etaPilot = options.etaPilot;
        
        this.response = new Promise<ClfResponse>((resolve) => {
            clfElement.addEventListener("submit", (e: Event) => {
                const detail = (e as CustomEvent).detail;
                resolve({
                    status: "submit",
                    reason: detail.reason,
                    reasonCode: detail.reasonCode,
                    comment: detail.comment,
                    date: detail.date,
                });
                this.removeClf(clfElement);
            });

            clfElement.addEventListener("cancel", () => {
                resolve({ status: "cancel" });
                this.removeClf(clfElement);
            });
        });
        const response = this.response;

        document.body.appendChild(this.clfElement);

        return {
            getResponse: () => response,
        };
    }

    removeClf(clfElement = this.clfElement){
        if(clfElement){
            clfElement.shown = false;
            clfElement.remove();
        }
        if (this.clfElement === clfElement) {
            this.clfElement = null;
            this.response = null;
        }
    }
}